jQuery(document).ready(function($){
	// if basket page is open
	if( $('#basket_page').length ){
		// attach data attribute to each link containing its full name for use later
		// the reason for this is that it gets over written
		$('#basket_page .cart .product-name a').each(function(){
			var prod_name = $(this).text();
			$(this).attr('name', prod_name);
		});

		trim_text();

		$(window).on('resize', function(){
			trim_text();
		});
	}

	function trim_text(){
		var window_width = $(window).width();
		
		$('#basket_page .cart .product-name a').each(function(){
			// full product name
			var prod_name = $(this).attr('name');

			if( window_width <= 500 && window_width > 420){
				if(prod_name.length > 30){
					var prod_name_trim = prod_name.substr(0,30) + '...';
					$(this).text(prod_name_trim);
				}
			}else if( window_width <= 420 && window_width > 359){
				if(prod_name.length > 20){
					var prod_name_trim = prod_name.substr(0,20) + '...';
					$(this).text(prod_name_trim);
				}
			}else if( window_width <= 359){
				if(prod_name.length > 15){
					var prod_name_trim = prod_name.substr(0,15) + '...';
					$(this).text(prod_name_trim);
				}
			}else{
				var current_prod_name = $(this).text();
				var full_prod_name = $(this).attr('name');
				
				// if the current product name isn't the full name then make it the full version
				if( full_prod_name != current_prod_name ){
					$(this).text(full_prod_name);
				}
			}
		});
	}	
});